"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunkQ4G2SZRDjs = require('./chunk-Q4G2SZRD.js');

// src/metrika-postman/index.ts
function paramsInTree(params) {
  params = params.slice().reverse();
  return params.reduce((prev, curr) => {
    const o = {};
    o[curr] = prev;
    return o;
  });
}
function getCounter(id) {
  return _chunkQ4G2SZRDjs.__async.call(void 0, this, null, function* () {
    return new Promise((resolve) => {
      id = Number(id);
      if (!id || isNaN(id)) {
        return null;
      }
      let counter = window[`yaCounter${id}`];
      if (counter) {
        return resolve(counter);
      }
      const tryCreateCounter = () => {
        if (window.Ya && window.Ya.Metrika2) {
          counter = new Ya.Metrika2({ id });
          return resolve(counter);
        }
        setTimeout(() => {
          tryCreateCounter();
        }, 1e3);
      };
      tryCreateCounter();
    });
  });
}
function sendParamsToMetrika(counterIndex, params) {
  return _chunkQ4G2SZRDjs.__async.call(void 0, this, null, function* () {
    return getCounter(counterIndex).then((counter) => {
      counter.params(paramsInTree(params));
    });
  });
}
function sendGoalToMetrika(counterIndex, goal) {
  return _chunkQ4G2SZRDjs.__async.call(void 0, this, null, function* () {
    return getCounter(counterIndex).then((counter) => {
      counter.reachGoal(goal);
    });
  });
}






exports.paramsInTree = paramsInTree; exports.getCounter = getCounter; exports.sendParamsToMetrika = sendParamsToMetrika; exports.sendGoalToMetrika = sendGoalToMetrika;
//# sourceMappingURL=chunk-WCNPLMX6.js.map